import { Chip } from '@mui/material'
import { useTranslation } from '@i18n'
import { getStatusColor } from '@utils/helpers'

/**
 * Status Chip Component
 */
const StatusChip = ({ status, size = 'small' }) => {
    const { t } = useTranslation()

    return (
        <Chip
            label={t(`status.${status}`)}
            color={getStatusColor(status)}
            size={size}
            sx={{
                fontWeight: 500,
                borderRadius: '8px',
            }}
        />
    )
}

export default StatusChip
